import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'error',
    `
		margin-bottom: 20px;
	`
  ],
  [
    'reCAPTCHA',
    `
		margin-bottom: 30px;
	`
  ]
]);
